// extracted by mini-css-extract-plugin
module.exports = {"col":"Table_col__2Aj2n","checkboxCol":"Table_checkboxCol__5Wyrh","emailCol":"Table_emailCol__2f2N-","actionCol":"Table_actionCol__XfwHb"};